import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetReportsChartsDataQuery } from "@/store/api";
import { useEffect, useState } from "react";
import { LoaderImage } from "@/utils/loader";
import { ReportsChartItem } from "./chartItem";
export var ReportsChart = function (_a) {
    var id = _a.id;
    var _b = useState([]), chartData = _b[0], setChartData = _b[1];
    var _c = useGetReportsChartsDataQuery({
        id: id,
    }), reportChartresponse = _c.data, isLoading = _c.isLoading;
    useEffect(function () {
        if (reportChartresponse) {
            setChartData(reportChartresponse.data);
        }
    }, [reportChartresponse]);
    return (_jsxs(_Fragment, { children: [isLoading && _jsx(LoaderImage, {}), chartData &&
                chartData.length > 0 &&
                chartData.map(function (item, index) { return (_jsx(ReportsChartItem, { chartData: item.values, chartType: item.type }, index)); })] }));
};
